package fyi.moko.hotpl.data.network

import fyi.moko.hotpl.domain.model.SyncState
import fyi.moko.hotpl.domain.model.Visit
import kotlinx.serialization.Serializable

@Serializable
data class RemoteVisitDto(
    val id: String,
    val placeId: String,
    val ownerId: String,
    val note: String?,
    @Serializable(with = FirestoreLong::class)
    val visitedAt: Long,
    val emotion: String?,
    /**
     * Only the file name travels — the bytes never leave the device (see
     * [fyi.moko.hotpl.domain.model.Visit.imageFileName]). Same deal as
     * [RemotePlaceDto.imageFileName]: another device resolves it to nothing and draws
     * the visit without a photo. Defaulted so visits written before this field existed
     * still deserialize.
     */
    val imageFileName: String? = null,
    /** 사진 목록. 이 필드를 모르는 구버전이 쓴 문서에서는 [imageFileName] 한 장으로 되살린다. */
    val photos: List<PhotoRefDto> = emptyList(),
    @Serializable(with = FirestoreLong::class)
    val version: Long,
    val isDeleted: Boolean,
    @Serializable(with = FirestoreLong::class)
    val createdAt: Long,
    @Serializable(with = FirestoreLong::class)
    val updatedAt: Long,
)

fun Visit.toRemoteDto(): RemoteVisitDto = RemoteVisitDto(
    id = id,
    placeId = placeId,
    ownerId = ownerId,
    note = note,
    visitedAt = visitedAt,
    emotion = emotion,
    imageFileName = imageFileName,
    photos = photos.map { PhotoRefDto(it.fileName, it.kind?.name) },
    version = version,
    isDeleted = isDeleted,
    createdAt = createdAt,
    updatedAt = updatedAt,
)

fun RemoteVisitDto.toDomain(): Visit = Visit(
    id = id,
    placeId = placeId,
    note = note,
    visitedAt = visitedAt,
    emotion = emotion,
    imageFileName = imageFileName,
    photos = photos.toDomainPhotos(imageFileName),
    ownerId = ownerId,
    syncState = SyncState.SYNCED,
    version = version,
    isDeleted = isDeleted,
    createdAt = createdAt,
    updatedAt = updatedAt,
)